/**
 * Created by elmer on 29/06/17.
 */
import Vue from 'vue';

function getCampaignIndex(state, campaign) {
  let campaignIndex = false;
  state.campaigns.forEach((e, index, arr) => {
    if (e.id === campaign.id) {
      campaignIndex = index;
    }
  });
  return campaignIndex;
}

export function saveCampaigns(state, campaigns) {
  Vue.set(state, 'campaigns', campaigns);
}

export function addCampaign(state, campaign) {
  const { campaigns } = state;
  campaigns.push(campaign);
  Vue.set(state, 'campaigns', campaigns);
}

export function removeCampaign(state, campaign) {
  const campaignIndex = getCampaignIndex(state, campaign);
  if (campaignIndex !== false) {
    const { campaigns } = state;
    campaigns.splice(campaignIndex, 1);
    Vue.set(state, 'campaigns', campaigns);
  }
}

export function setCampaign(state, campaign) {
  Vue.set(state, 'selectedCampaign', campaign);
}

export function setArchivosPublicidad(state, archivos) {
  Vue.set(state, 'archivos_publicidad', archivos);
}

export function addUpload(state, upload) {
  const { archivos_publicidad } = state;
  archivos_publicidad.push(upload);
  console.log('add upload to state', upload);
  Vue.set(state, 'archivos_publicidad', archivos_publicidad);
}

export function addUploads(state, campaign, uploads) {
  const archivosPublicidad = [
    ...state.archivos_publicidad,
    ...uploads,
  ];
  Vue.set(state, 'archivos_publicidad', archivosPublicidad);
}

export function removeUpload(state, upload) {
  const { archivos_publicidad } = state;
  const archivo = archivos_publicidad.find(e => e.id === upload.id);
  const publicidadIndex = archivos_publicidad.indexOf(archivo);
  if (publicidadIndex !== -1) {
    archivos_publicidad.splice(publicidadIndex, 1);
    Vue.set(state, 'archivos_publicidad', archivos_publicidad);
  }
}

export function togglePublicidad(state, payload) {
  const { item, estado } = payload;
  const { archivos_publicidad } = state;
  const archivo = archivos_publicidad.find(e => e.id === item.id);
  const uploadIndex = archivos_publicidad.indexOf(archivo);
  archivos_publicidad[uploadIndex].estado = estado;
  Vue.set(state, 'archivos_publicidad', archivos_publicidad);
}

export function editUpload(state, payload) {
  const { id, data } = payload;
  const { archivos_publicidad } = state;
  const archivo = archivos_publicidad.find(e => e.id === id);
  const uploadIndex = archivos_publicidad.indexOf(archivo);
  Vue.set(state, 'archivos_publicidad', []);
  archivos_publicidad[uploadIndex] = {
    ...archivos_publicidad[uploadIndex],
    ...data,
  };
  Vue.set(state, 'archivos_publicidad', archivos_publicidad);
}



// WEBPACK FOOTER //
// ./src/modules/admin/publicidad.mutations.js